import React, { useState } from "react";
import { Images, X, Mic, FileDown } from "lucide-react";

const mediaUrl = (u) => (u?.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

// Album degli auguri: foto (tutto schermo al tocco), vocali e video degli amici che hanno partecipato
export default function WishAlbum({ items, title = "Album degli auguri", compact = false, pdfUrl }) {
  const [full, setFull] = useState(null);
  const list = (items || []).filter((i) => i.media || i.message);
  if (!list.length) return null;
  const withMedia = list.filter((i) => i.media).length;
  return (
    <div id="album" className="rounded-2xl bg-white p-4 ring-1 ring-zinc-200 space-y-3" data-testid="wish-album">
      <div className="flex items-center justify-between">
        <div className="font-heading font-bold text-sm flex items-center gap-1.5"><Images className="h-4 w-4" /> {title}</div>
        <span className="text-xs text-zinc-500">{list.length} amici{withMedia ? ` · ${withMedia} con foto/vocale/video` : ""}</span>
      </div>
      {pdfUrl && <a href={pdfUrl} target="_blank" rel="noreferrer" style={{ color: "#fff", background: "#18181b" }} className="inline-flex items-center gap-1.5 rounded-full text-xs font-semibold px-3 py-1.5 hover:opacity-90" data-testid="wish-album-pdf"><FileDown className="h-3.5 w-3.5" /> Scarica l'album ricordo (PDF)</a>}
      <div className={compact ? "space-y-2" : "grid sm:grid-cols-2 gap-3"}>
        {list.map((it, i) => (
          <div key={i} className="rounded-xl bg-zinc-50 p-3 space-y-2" data-testid={`wish-item-${i}`}>
            <div className="flex items-baseline justify-between gap-2"><b className="text-sm">{it.name}</b>{it.at && <span className="text-[11px] text-zinc-400">{new Date(it.at).toLocaleDateString("it-IT")}</span>}</div>
            {it.message && <p className="text-sm italic text-zinc-700">«{it.message}»</p>}
            {it.media?.kind === "photo" && (
              <button type="button" onClick={() => setFull(it)} className="block w-full" data-testid={`wish-photo-${i}`}>
                <img src={mediaUrl(it.media.url)} alt={`Augurio di ${it.name}`} className="w-full max-h-56 object-cover rounded-lg hover:opacity-95 transition" loading="lazy" />
              </button>
            )}
            {it.media?.kind === "audio" && (
              <div className="flex items-center gap-2" data-testid={`wish-audio-${i}`}><Mic className="h-4 w-4 text-zinc-500 shrink-0" /><audio controls preload="none" src={mediaUrl(it.media.url)} className="h-9 w-full min-w-0" /></div>
            )}
            {it.media?.kind === "video" && (
              <video controls playsInline preload="metadata" src={mediaUrl(it.media.url)} className="w-full max-h-72 rounded-lg bg-black" data-testid={`wish-video-${i}`} />
            )}
          </div>
        ))}
      </div>
      {full && (
        <div className="fixed inset-0 z-[90] bg-black/95 flex items-center justify-center p-3" onClick={() => setFull(null)} role="dialog" aria-modal="true" data-testid="wish-fullscreen">
          <button type="button" className="absolute top-3 right-3 text-white/80 hover:text-white" onClick={() => setFull(null)} aria-label="Chiudi" data-testid="wish-fullscreen-close"><X className="h-7 w-7" /></button>
          <figure className="max-w-3xl w-full text-center" onClick={(e) => e.stopPropagation()}>
            <img src={mediaUrl(full.media.url)} alt={`Augurio di ${full.name}`} className="max-h-[80vh] w-auto mx-auto rounded-xl object-contain" />
            <figcaption className="text-white/90 text-sm mt-3"><b>{full.name}</b>{full.message && <> · «{full.message}»</>}</figcaption>
          </figure>
        </div>
      )}
    </div>
  );
}
